export function formatShortNumber(number: number) {
  const _number = Number(number);

  if (Number.isNaN(_number)) {
    return 'Invalid number';
  }

  if (_number < 1_000) {
    return _number;
  }

  if (_number < 1_000_000) {
    return `${(_number / 1_000).toFixed(2).replace('.', ',')}k`;
  }

  return `${(_number / 1_000_000).toFixed(2).replace('.', ',')}mln`;
}
